<template>
  <NiceModal :name="props.name" :title="props.title" @close="cancel">
    <!-- Slot -->
    <slot>
      <p class="p-0 m-0">{{ props.message }}</p>
    </slot>

    <!-- Loading -->
    <NiceLoading fullDiv v-if="loading"></NiceLoading>

    <template #footer>
      <!-- Cancel -->
      <NiceButton :text="$gettext('Cancel')" @click="cancel" type="default" plain icon="icon-x" />

      <!-- Confirm -->
      <NiceButton :text="$gettext('Confirm')" @click="confirm" icon="icon-check" />
    </template>
  </NiceModal>
</template>

<script setup>
import { defineProps, defineEmits, inject } from "vue";
const nice = inject("nice");
const emit = defineEmits(["cancel", "confirm"]);
const props = defineProps({
  name: {
    type: String,
    default: () => "confirm-prompt",
  },
  Title: {
    type: String,
    default: () => "",
  },
  message: {
    type: String,
    default: () => "",
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

function cancel() {
  nice.modal(props.name, false);
  emit("cancel");
}

function confirm() {
  emit("confirm");
}
</script>
